import { memo } from "react";

const fitSize = (text, max = 22, width = 470) => {
  const len = (text || "").length;
  if (!len) return max;
  return Math.max(11, Math.min(max, width / (len * 0.66)));
};

const Stars = () => {
  const pts = Array.from({ length: 12 }, (_, i) => {
    const a = (i / 12) * Math.PI * 2;
    return [55 + Math.cos(a) * 13, 78 + Math.sin(a) * 13];
  });
  return pts.map(([x, y], i) => <circle key={i} cx={x} cy={y} r="2" fill="#FFD400" />);
};

const Plate = ({ plate }) => (
  <g>
    <rect x="30" y="44" width="540" height="112" rx="9" fill="#ffffff" stroke="#0b0b0d" strokeWidth="3" />
    <path d="M39 44 h41 v112 h-41 a9 9 0 0 1 -9 -9 v-94 a9 9 0 0 1 9 -9z" fill="#003399" />
    <Stars />
    <text x="55" y="134" textAnchor="middle" fill="#fff" fontSize="22" fontWeight="700" fontFamily="Montserrat, sans-serif">
      LV
    </text>
    <text
      x="325"
      y="126"
      textAnchor="middle"
      fill="#0b0b0d"
      fontSize="78"
      fontWeight="700"
      letterSpacing="4"
      fontFamily="Montserrat, sans-serif"
    >
      {plate}
    </text>
  </g>
);

export const PlatePreview = memo(function PlatePreview({
  type = "individual",
  top = "",
  bottom = "",
  color = "#FFFFFF",
  plate = "AB-1234",
  className = "",
  testId,
  hiddenLabel = "ДЕРЖАТЕЛЬ СКРЫТ ЗА НОМЕРОМ",
}) {
  if (type === "invisible") {
    return (
      <svg viewBox="0 0 600 200" className={className} role="img" aria-label="Превью: невидимый держатель номера" data-testid={testId}>
        {/* hidden holder behind the plate */}
        <rect x="60" y="60" width="480" height="80" rx="8" fill="none" stroke="#a1a1aa" strokeWidth="2" strokeDasharray="8 7" />
        <g style={{ filter: "drop-shadow(0 12px 14px rgba(0,0,0,0.18))" }}>
          <Plate plate={plate} />
        </g>
        {[[110, 36], [490, 36], [110, 164], [490, 164]].map(([x, y], i) => (
          <rect key={i} x={x - 14} y={y - 4} width="28" height="8" rx="3" fill="#0b0b0d" />
        ))}
        <text x="300" y="192" textAnchor="middle" fill="#71717a" fontSize="12" letterSpacing="3" fontFamily="IBM Plex Mono, monospace">
          {hiddenLabel}
        </text>
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 600 200" className={className} role="img" aria-label="Превью номерной рамки" data-testid={testId}>
      <defs>
        <linearGradient id="rpmFrame" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#2a2a2f" />
          <stop offset="0.5" stopColor="#0b0b0d" />
          <stop offset="1" stopColor="#1a1a1e" />
        </linearGradient>
      </defs>
      <rect x="6" y="4" width="588" height="192" rx="22" fill="url(#rpmFrame)" />
      <rect x="10" y="8" width="580" height="184" rx="19" fill="none" stroke="rgba(255,255,255,0.10)" strokeWidth="1.5" />
      {/* layer lines (3D-print texture) */}
      {Array.from({ length: 10 }, (_, i) => (
        <line key={i} x1="20" x2="580" y1={12 + i * 3} y2={12 + i * 3} stroke="rgba(255,255,255,0.035)" strokeWidth="1" />
      ))}
      <Plate plate={plate} />
      {/* screw caps */}
      {[[140, 26], [460, 26], [140, 176], [460, 176]].map(([x, y], i) => (
        <circle key={i} cx={x} cy={y} r="5" fill="#2f2f35" stroke="#45454d" strokeWidth="1" />
      ))}
      <text
        x="300"
        y="33"
        textAnchor="middle"
        fill={color}
        fontSize={fitSize(top, 22, 260)}
        fontWeight="600"
        letterSpacing="2"
        fontFamily="Montserrat, sans-serif"
        data-testid={testId ? `${testId}-top` : undefined}
      >
        {top || " "}
      </text>
      <text
        x="300"
        y="184"
        textAnchor="middle"
        fill={color}
        fontSize={fitSize(bottom, 20, 260)}
        fontWeight="600"
        letterSpacing="2"
        fontFamily="Montserrat, sans-serif"
        data-testid={testId ? `${testId}-bottom` : undefined}
      >
        {bottom || " "}
      </text>
    </svg>
  );
});
